import * as types from './types';

/**
 * ---------------------------------------------------
 * ENVIA INDICADORES GERAIS
 * ---------------------------------------------------
 */

export function generalIndicatorsRequest(payload) {
  return {
    type: types.GENERAL_INDICATORS_REQUEST,
    payload,
  };
}

export function generalIndicatorsSuccess(payload) {
  return {
    type: types.GENERAL_INDICATORS_SUCCESS,
    payload,
  };
}

export function generalIndicatorsFailure(payload) {
  return {
    type: types.GENERAL_INDICATORS_FAILURE,
    payload,
  };
}

/**
 * ---------------------------------------------------
 * GET COMPETENCIAS
 * ---------------------------------------------------
 */

export function generalCompetencesRequest() {
  return {
    type: types.GENERAL_COMPETENCES_REQUEST,
  };
}

export function generalCompetencesSuccess(payload) {
  return {
    type: types.GENERAL_COMPETENCES_SUCCESS,
    payload,
  };
}

export function generalCompetencesFailure() {
  return {
    type: types.GENERAL_INDICATORS_FAILURE,
  };
}
